import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import {
  DropdownMenu, DropdownMenuTrigger, DropdownMenuContent,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { Bell } from "lucide-react";

export default function NotificationBell() {
  const { user } = useAuth();
  const nav = useNavigate();
  const [data, setData] = useState({ items: [], unread: 0 });

  const load = async () => {
    try { const { data } = await api.get("/notifications"); setData(data); } catch (e) { console.error("Failed to load notifications:", e); }
  };

  useEffect(() => {
    if (!user) return;
    load();
    const t = setInterval(load, 30000);
    return () => clearInterval(t);
  }, [user]);

  if (!user) return null;

  const openMenu = async (open) => {
    if (!open && data.unread > 0) {
      try { await api.post("/notifications/read-all"); load(); } catch (e) { console.error("Failed to mark notifications read:", e); }
    }
  };

  const goTo = (n) => {
    if (n.kind === "follow" || n.kind === "message") nav(`/nurses/${n.actor_id}`);
    else if (n.kind === "reply") nav(`/forums/${n.target_id}`);
    else if (n.kind === "comment") nav(`/feed`);
  };

  return (
    <DropdownMenu onOpenChange={openMenu}>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" data-testid="notif-bell" className="relative border-2 border-black rounded-none nh-hover-push h-9 w-9 p-0">
          <Bell className="w-4 h-4" />
          {data.unread > 0 && (
            <span className="absolute -top-1.5 -right-1.5 bg-[hsl(var(--nh-red))] text-white text-[10px] font-black border-2 border-black min-w-[18px] h-[18px] px-0.5 flex items-center justify-center" data-testid="notif-count">
              {data.unread}
            </span>
          )}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="border-2 border-black rounded-none bg-white w-80 p-0">
        <div className="p-3 border-b-2 border-black bg-[hsl(var(--nh-yellow))] font-black text-sm uppercase tracking-widest">Notifications</div>
        <div className="max-h-80 overflow-y-auto">
          {data.items.length === 0 && <div className="p-4 text-sm text-black/50">All caught up.</div>}
          {data.items.map(n => (
            <button key={n.id} onClick={() => goTo(n)} data-testid={`notif-${n.id}`}
              className={`w-full text-left p-3 border-b border-black/10 hover:bg-[hsl(var(--nh-bg))] ${!n.read ? "bg-[hsl(var(--nh-mint))]/20" : ""}`}>
              <div className="text-sm"><b>{n.actor?.name || "Someone"}</b> {n.text.replace(n.actor?.name || "", "").replace(/^\s+/,"")}</div>
              <div className="text-xs text-black/50 mt-0.5">{new Date(n.created_at).toLocaleString()}</div>
            </button>
          ))}
        </div>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
